export default __webpack_public_path__ + "static/media/blue_users.af237164.svg";